import React from 'react';

import { routeDirectory } from 'modules';
import {
  Navigate, useLocation
} from 'react-router-dom';

import * as dataService from '../dataService';



interface IProps {
  appAuthStatus: dataService.IAppAuthStatus | null;
  children: React.ReactNode | React.ReactNode[];
}

export const FC: React.FC<IProps> = props => {
  const location = useLocation();

  if (props.appAuthStatus === null) {
    return null;
  }

  // If we don't do the onboarded check here, then the app always redirects home.
  if (props.appAuthStatus && props.appAuthStatus !== 'onboarded' && location.pathname !== __authStatus2Path[props.appAuthStatus]) {
    return (
      <Navigate
        to={__authStatus2Path[props.appAuthStatus]}
        replace />
    );
  }

  return <>{props.children}</>;
};



const __authStatus2Path: Record<dataService.IAppAuthStatus, string> = {
  // The real path contains a search param for a tab, so we can't do equality on that
  'isSuperAdmin': routeDirectory.superAdmin.dashboard.rawPath,
  'onboarded': routeDirectory.home.path(),
  'requiresUserType': routeDirectory.authentication.onboardingUserType.path(),
  'requiresProfileInformation': routeDirectory.authentication.onboardingProfile.path(),
  'requiresPaymentInformation': routeDirectory.authentication.onboardingPayment.path()
};
